import { useCallback, useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'hooks';

import { PlanUnitMix } from 'components/types';

import PlanUnitSelector from 'components/shared/PlanUnitSelector';

import OpenRequests from './OpenRequests';
import QualityMonitorStyles from './QualityMonitorStyles';
import TasksList from './TasksList';
import { setLastUsedPlanunit } from './actionCreators';
import { TabType } from '../Home';
import dayjs from 'dayjs';

interface QualityMonitorProps {
  setPage: (page: TabType, params?: Record<string, string>) => void;
  setIsLoading: (isLoading: boolean) => void;
}

export default function QualityMonitor({
  setPage,
  setIsLoading
}: QualityMonitorProps) {
  const { hasRosterPortalPlanModusAccess, hasRosterPortalMessagesAccess } =
    useSelector((state) => state.grants);
  const dispatch = useDispatch();
  const [lastUsedPlanunit] = useSelector(
    (state) => state.roster.home.qualityMonitor.lastUsedPlanunit
  );
  const [selectedPlanUnits, setSelectedPlanUnits] = useState<PlanUnitMix[]>([]);
  const [isLoadingOpenRequests, setIsLoadingOpenRequests] = useState(false);
  const [isLoadingTasks, setIsLoadingTasks] = useState(false);

  const onPlanunitSelected = useCallback(
    (value: PlanUnitMix[]) => {
      setSelectedPlanUnits(value);
      dispatch(setLastUsedPlanunit(value));
    },
    [dispatch]
  );

  useEffect(() => {
    if (!isLoadingOpenRequests && !isLoadingTasks) {
      setIsLoading(false);
    }
    if (isLoadingOpenRequests || isLoadingTasks) {
      setIsLoading(true);
    }
  }, [isLoadingOpenRequests, isLoadingTasks, setIsLoading]);

  return (
    <QualityMonitorStyles>
      <PlanUnitSelector
        onSelected={onPlanunitSelected}
        firstOptionIsDefault
        defaultValue={lastUsedPlanunit ? [lastUsedPlanunit] : undefined}
      />
      <div className="widgets">
        <div className="left-side">
          {hasRosterPortalPlanModusAccess && (
            <OpenRequests
              selectedPlanUnits={selectedPlanUnits}
              setIsLoading={setIsLoadingOpenRequests}
            />
          )}
        </div>
        {hasRosterPortalMessagesAccess && (
          <div className="right-side">
            {hasRosterPortalMessagesAccess && (
              <TasksList
                selectedPlanUnits={selectedPlanUnits}
                openTab={(
                  tabType: TabType,
                  payload?: { [key: string]: any }
                ) => {
                  const date = dayjs(payload?.dateOfMonth).isValid()
                    ? dayjs(payload?.dateOfMonth).format('DD-MM-YYYY')
                    : '';

                  tabType === TabType.TRAVEL_EXPENSE_CLAIMS && date
                    ? setPage(tabType, { date })
                    : setPage(tabType);
                }}
                setIsLoading={setIsLoadingTasks}
              />
            )}
          </div>
        )}
      </div>
    </QualityMonitorStyles>
  );
}
